import type { PredefinedValueType } from "app/pages/sales-intelligence/sub-modules/management/store/type";

export const OVER_THE_LIMIT_LENGTH = 35;

export const hintByDataType: Record<PredefinedValueType, string> = {
    Text: "si.management.integration.export.cell.example.hint.text",
    Picklist: "si.management.integration.export.cell.example.hint.pickList",
    Numeric: "si.management.integration.export.cell.example.hint.numeric",
    Boolean: "si.management.integration.export.cell.example.hint.boolean",
    Date: "si.management.integration.export.cell.example.hint.date",
    DateTime: "si.management.integration.export.cell.example.hint.datetime",
    Reference: "si.management.integration.export.cell.example.hint.reference",
};

export const validErrorTooltipsByDataType: Record<PredefinedValueType, string> = {
    Text: "si.management.integration.export.cell.example.validation.text.error",
    Picklist: "si.management.integration.export.cell.example.validation.list.error",
    Numeric: "si.management.integration.export.cell.example.validation.numeric.error",
    Boolean: "si.management.integration.export.cell.example.validation.boolean.error",
    Date: "",
    DateTime: "",
    Reference: "si.management.integration.export.cell.example.validation.reference.error",
};

export const CRM_FIELD = "crm-field";
export const CRM_CELL = "crm-cell";
export const SIMILARWEB_FIELD = "similarweb-field";

export const CRM_CELL_PLACEHOLDER = "si.management.integration.export.crm.cell.placeholder";
export const INVALID_DATA_TYPE_WARNING = "si.management.integration.export.crm.cell.invalid-data-type-warning";
export const INVALID_DATA_TYPE_WARNING_BODY =
    "si.management.integration.export.crm.cell.invalid-data-type-warning.body";
export const INVALID_DATA_TYPE_WARNING_COMPATIBLE =
    "si.management.integration.export.crm.cell.invalid-data-type-warning.compatible";
export const FIELD_ALREADY_IN_USE_WARNING = "si.management.integration.export.crm.cell.field-already-in-use-warning";
export const SIMILARWEB_CELL_PLACEHOLDER = "si.management.integration.export.add_field.modal.placeholder";
export const MANDATORY_FIELDS_GROUP_LABEL = "si.management.integration.export.mandatory-fields-group-label";
export const ALL_FIELDS_GROUP_LABEL = "si.management.integration.export.all-fields-group-label";

export const CRM_EXPORT_DROPDOWN_HEIGHT = 300;
export const CRM_EXPORT_DROPDOWN_WIDTH = 400;
export const NUMBER_OF_ITEMS_IN_CRM_DD = 4;
